import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=35a22c30&scoped=true&lang=css"
import "./Header.vue?vue&type=style&index=1&id=35a22c30&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Andre\\OneDrive\\Desktop\\Documents\\GitHub\\vue-covid-tracker\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a22c30"]])

export default __exports__